import { UserRepository } from '@src/domain/repositories'

export interface PagePermissionsBo extends UserRepository.GetPagePermissionsRespDto {}

export async function getPagePermissions(): Promise<PagePermissionsBo> {
  const pagePermissionsDto = await UserRepository.getPagePermissions()

  return pagePermissionsDto
}

export interface RolesBo extends UserRepository.GetRolesRespDto {}

/** 取得角色清單 */
export async function getRoles(): Promise<RolesBo> {
  const rolesDto = await UserRepository.getRoles()

  return rolesDto
}

export interface PermissionsBo extends UserRepository.GetPermissionsRespDto {}

/** 取得權限清單 */
export async function getPermissions(): Promise<PermissionsBo> {
  const permissionsDto = await UserRepository.getPermissions()

  return permissionsDto
}

export interface FactoriesBo extends UserRepository.FactoriesRespDto {}

/** 取得廠區清單 */
export async function getFactories(): Promise<FactoriesBo> {
  const factoriesDto = await UserRepository.getFactories()

  return factoriesDto
}
